import React, { useState, useEffect } from "react";
import BusinessAdministrationHeader from "../components/Courses/BusinessAdministration/BusinessAdministrationHeader";
import BusinessAdministrationCareerSkills from "../components/Courses/BusinessAdministration/BusinessAdministrationCareerSkills";
import BusinessAdministrationAdmissionRequirements from "../components/Courses/BusinessAdministration/BusinessAdministrationAdmissionRequirements";
import ProgramDuration from "../components/Courses/Shared/ProgramDuration";
import ProgramBenefits from "../components/Courses/Shared/ProgramBenefits";
import StudentAcceptanceForm from "../components/Courses/Shared/StudentAcceptanceForm";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";
import cmsApi from "../services/cmsApi";

const BUSINESS_ADMINISTRATION_BENEFITS = [
  "High Demand, Guaranteed Relevance — A Business Administration qualification opens doors across virtually every sector, including finance, banking, marketing, human resources, NGOs, government, and corporate management.",
  "Strong Earning Potential — Graduates qualify for well-paying roles such as Business Manager, Marketing Executive, Financial Analyst, Operations Manager, and Human Resources Manager.",
  "Real Business Knowledge — You will learn accounting, financial planning, marketing strategy, and operations management — the core functions that keep any organization running successfully.",
  "Leadership and Communication Skills — Our program develops your ability to lead teams, make sound decisions under pressure, and communicate effectively at all levels of an organization.",
  "Entrepreneurship Ready — If you dream of running your own business, this program gives you the practical foundation: business planning, financial management, and market analysis.",
  "Globally Recognized Principles — Business fundamentals are consistent worldwide. Your qualification and skills are applicable not just in Tanzania but in regional and international markets.",
];

const BUSINESS_ADMINISTRATION_CAREER_PATHS =
  "Graduates commonly go on to become Business Managers, Marketing Managers, Financial Analysts, Human Resource Managers, and Entrepreneurs.";

const BusinessAdministration = () => {
  const [pageComponents, setPageComponents] = useState({});
  const [loading, setLoading] = useState(true);
  const [, setError] = useState(null);

  useEffect(() => {
    // Only fetch on client side to avoid hydration issues
    if (typeof window === 'undefined') return;

    const fetchPageData = async () => {
      try {
        setLoading(true);
        
        // Fetch all page components for Business Administration page
        const result = await cmsApi.getPageComponents('business-administration');
        
        if (result.success && result.components) {
          // Filter to only active components and organize by componentName
          const componentsMap = {};
          result.components
            .filter(comp => comp.isActive !== false) // Only show active components
            .forEach(comp => {
              componentsMap[comp.componentName] = comp;
            });
          setPageComponents(componentsMap);
        } else {
          console.warn('No page components found, using defaults');
        }
      } catch (error) {
        console.error('Error fetching Business Administration page data:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPageData();
  }, []);

  // Show loading state (optional)
  if (loading && typeof window !== 'undefined') {
    return (
      <div>
        <Navbar />
        <div className="mid-desktop-page">
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-custom-pink border-t-transparent mx-auto mb-4"></div>
            <p className="text-gray-600">Loading Business Administration page...</p>
          </div>
        </div>
        </div>
        <Footer />
        <FloatingSocialPanels />
      </div>
    );
  }

  // Always render components - they have default content if CMS data is missing
  const headerComponent = pageComponents.header;
  const careerSkillsComponent = pageComponents['career-skills'];
  const admissionRequirementsComponent = pageComponents['admission-requirements'];

  return (
    <div>
      <Navbar />
      <div className="mid-desktop-page">
      {/* Hero Section - Always render with defaults if no CMS data */}
      <BusinessAdministrationHeader componentData={headerComponent} />
      {/* Career Skills Section - Always render with defaults if no CMS data */}
      <BusinessAdministrationCareerSkills componentData={careerSkillsComponent} />
      {/* Course Duration */}
      <ProgramDuration />
      {/* Why Choose Business Administration at JRIIT? */}
      <ProgramBenefits
        programName="Business Administration"
        benefits={BUSINESS_ADMINISTRATION_BENEFITS}
        careerPaths={BUSINESS_ADMINISTRATION_CAREER_PATHS}
      />
      {/* Admission Requirements Section - Always render with defaults if no CMS data */}
      <BusinessAdministrationAdmissionRequirements componentData={admissionRequirementsComponent} />
      {/* Student Acceptance Form */}
      <StudentAcceptanceForm programName="Business Administration" />
      <FullScreenImage />
      </div>
      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default BusinessAdministration;
